export const settingsConfig = {
  searchStatusFilter: [
    {
      label: 'Select Payment Type',
      value: 'paymentType',
    },
    {
      value: 'WAITING_FOR_WP_FEE',
      label: 'Work Permit Fee',
    },
    {
      value: 'READY_TO_PAY',
      label: 'Processing Fee',
    },
  ],
  tableHeaders: [
    {
      key: 'Email',
      filterTypes: [
        {
          label: 'Contains',
          type: 'text',
          id: 'email',
        },
        {
          label: 'Equal',
          type: 'text',
          id: 'email',
        },
      ],
    },
    {
      key: 'First Name',
      filterTypes: [
        {
          label: 'ContainsCI',
          type: 'text',
          id: 'firstName',
        },
      ],
    },
    {
      key: 'Last Name',
      filterTypes: [
        {
          label: 'ContainsCI',
          type: 'text',
          id: 'lastName',
        },
      ],
    },
  ],
};
